//
export default {
  TT107: 1,
  defaultType: 0,
  MXP: 2,
};
